import { EllipsedText, FlexColumn, FlexRow, LabeledData } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { HeadingXSmall, ParagraphSmall } from 'baseui/typography';
import { memo, useEffect } from 'react';
import { createPortal } from 'react-dom';
import {
  COMMANDS_STATUS,
  COMMAND_EXPIRED_STATUS,
  COMMAND_PENDING_STATUS,
  COMMAND_SUCCESS_STATUS,
} from '../../../constants/commands';
import { useStyles } from '../../../hooks/useStyles';
import { Command } from '../../../types/command';

type Props = {
  onClose: () => void;
  isOpen: boolean;
  command?: Command;
};

function CommandDetailModal({ onClose, isOpen, command }: Props) {
  const { css, theme, classes } = useStyles();

  useEffect(() => {
    if (!command) resetModal();
  }, [command]);

  const resetModal = () => {
    onClose();
  };

  return createPortal(
    <Modal
      animate
      closeable
      onClose={resetModal}
      isOpen={isOpen}
    >
      <ModalHeader>
        <FlexRow
          gap={theme.sizing.scale200}
          classNames={classes.centeredStart}
        >
          <HeadingXSmall margin={0}>Comando</HeadingXSmall>
        </FlexRow>
      </ModalHeader>
      <ModalBody>
        <FlexColumn classNames={css({ padding: theme.sizing.scale500 })}>
          <LabeledData
            label={'Usuario:'}
            content={`${command?.user.username}`}
          />
          <LabeledData
            label={'Estatus:'}
            content={
              <ParagraphSmall
                margin={0}
                color={
                  command?.status === COMMAND_SUCCESS_STATUS
                    ? theme.colors.positive
                    : command?.status === COMMAND_PENDING_STATUS
                    ? theme.colors.warning
                    : command?.status === COMMAND_EXPIRED_STATUS
                    ? theme.colors.negative
                    : theme.colors.contentSecondary
                }
              >
                <EllipsedText inline>{`${COMMANDS_STATUS[command?.status || '']}`}</EllipsedText>
              </ParagraphSmall>
            }
          />
          <LabeledData
            label={'Logs:'}
            content={`${command?.logMessage}`}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body
  );
}

export default memo(CommandDetailModal);
